import React from 'react';
import Layout from '../components/layout';
import Contact from '../components/contactus';

const ContactPage = ({ location }) => (
	<Layout
		title={'Contact Lan Linville Drafting'}
		description={'Please fill out the form to receive a call from Lan or call (916) 773-2020'}
		location={location}
	>
		<Contact />
	</Layout>
);
export default ContactPage;
